import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NodeApiService} from '../node/node-api.service';
import {PeerConnectionApiService} from '../../../peer-connection/peer-connection-api.service';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {VoipPeerApiService} from '../voip-peer/voip-peer-api.service';
import {CallsQuotaApiService} from '../../../settings/routing/calls-quota/calls-quota-api.service';

@Injectable({
  providedIn: 'root'
})
export class ResourceGroupsApiService {

  constructor(private http: HttpClient,
              private nodeService: NodeApiService,
              private pConService: PeerConnectionApiService,
              private voipPeerService: VoipPeerApiService,
              private callsQuotaApiService: CallsQuotaApiService) {}

  readonly groupsUrl: string = 'topology/group';

  public getGroups(params: any = {}): Promise<any> {
    params = UrlQueryService.restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(this.groupsUrl, params);

    return this.http.get(url).toPromise();
  }

  public getGroup(id): Promise<any> {
    const url = this.groupsUrl + '/' + id;
    return this.http.get(url).toPromise();
  }

  public editGroup(group: any): Promise<any> {
    const url = `${this.groupsUrl}/${group.id}`;
    return this.http.put(url, group).toPromise();
  }

  public addGroup(group: any): Promise<any> {
    return this.http.post(this.groupsUrl, group).toPromise();
  }

  public deleteGroup(id): Promise<any> {
    const url = `${this.groupsUrl}/${id}`;
    return this.http.delete(url).toPromise();
  }

  public prepareData(): Promise<any> {
    return Promise.all([
        this.nodeService.getNodes().then(nodes => this.getIdAndName(nodes)),
        this.pConService.getPCons().then((pCons: any) => this.preparePCons(pCons.elements)),
        this.voipPeerService.getVoipPeers().then(voipPeers => this.getIdAndName(voipPeers.elements)),
        this.callsQuotaApiService.getCallsQuotas().toPromise()
      ]
    );
  }

  getIdAndName(elements) {
    return elements.map(node => {return {
      id: node.id,
      name: node.name
    }; });
  }

  preparePCons(pCons) {
    return pCons.map(pCon => {return {
      id: pCon.id,
      name: `${pCon.name} (${pCon.nodeName})`,
      parentName: pCon.nodeName
    }; });
  }
}
